import gql from 'graphql-tag';
import ShippingMethodAllFragment from '../fragments/ShippingMethodAllFragment';

export default gql`
mutation UpdateShippingMethod (
    $id: ID!
    $name: String
    $is_active: Boolean
    $before: Int
    $after: Int
    $price_ranges: [ShippingMethodPriceRangeInput!]
    $max_weight: Int
    $description: String
    $short_description: String
    $delivery_time: String
  ) {
    adminUpdateShippingMethod (input: {
        id: $id,
        name: $name,
        is_active: $is_active,
        before: $before,
        after: $after,
        price_ranges: $price_ranges,
        max_weight: $max_weight,
        description: $description,
        short_description: $short_description,
        delivery_time: $delivery_time
    }) {
        ...ShippingMethodAllFragment
    }
}
${ShippingMethodAllFragment}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/mutations/updateShippingMethod.ts